const isResolvedResource = require('../contentful/is-resolved-resource');
const moment = require('moment');

const modelTransformer = require('./model');
const colorTransformer = require('./color');
const equipmentFactoryTransformer = require('./equipmentFactory');
const equipmentLevelTransformer = require('./equipmentLevel').default;
const makeTransformer = require('./make');
const variantTransformer = require('./variant');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,
      created: moment(entry.sys.createdAt).format('DD.MM.YYYY HH:mm'),
      title: (entry.fields.name ? entry.fields.name['nb-NO'] : ''),
      color: null, // this is the color displayed, if override is set, use this, if not, use original color
      colorOriginal: null,
      colorOverride: null,
      equipmentLevel: null,
      make: null,
      model: null,
      interior: null,
      stock: (entry.fields.stock ? entry.fields.stock['nb-NO'] : ''),
      variant: null,
      priceAdjustment: 0,
      tags: [],
      modified: null
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;
    }

    // Make
    if (entry.fields.make && entry.fields.make['nb-NO'] && isResolvedResource(entry.fields.make['nb-NO'])) {
      result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
    }

    // Model
    if (entry.fields.model && entry.fields.model['nb-NO'] && isResolvedResource(entry.fields.model['nb-NO'])) {
      result.model = modelTransformer.contentfulToInternal(entry.fields.model['nb-NO']);
    }

    // Model
    if (entry.fields.interior && entry.fields.interior['nb-NO'] && isResolvedResource(entry.fields.interior['nb-NO'])) {
      result.interior = equipmentFactoryTransformer.contentfulToInternal(entry.fields.interior['nb-NO']);
    }

    // Color
    if (entry.fields.color && entry.fields.color['nb-NO'] && isResolvedResource(entry.fields.color['nb-NO'])) {
      result.colorOriginal = colorTransformer.contentfulToInternal(entry.fields.color['nb-NO']);
    }
    if (entry.fields.colorOverride && entry.fields.colorOverride['nb-NO'] && isResolvedResource(entry.fields.colorOverride['nb-NO'])) {
      result.colorOverride = colorTransformer.contentfulToInternal(entry.fields.colorOverride['nb-NO']);
    }

    // equipmentLevel
    if (entry.fields.equipmentLevel && entry.fields.equipmentLevel['nb-NO'] && isResolvedResource(entry.fields.equipmentLevel['nb-NO'])) {
      result.equipmentLevel = equipmentLevelTransformer.contentfulToInternal(entry.fields.equipmentLevel['nb-NO']);
    }

    // equipmentLevel
    if (entry.fields.variant && entry.fields.variant['nb-NO'] && isResolvedResource(entry.fields.variant['nb-NO'])) {
      result.variant = variantTransformer.contentfulToInternal(entry.fields.variant['nb-NO']);
    }

    // Price adjustment
    if (entry.fields.priceAdjustment && entry.fields.priceAdjustment['nb-NO']) {
      result.priceAdjustment = entry.fields.priceAdjustment['nb-NO'];
    }

    // Tags
    if (entry.fields.tags && entry.fields.tags['nb-NO']) {
      result.tags = entry.fields.tags['nb-NO'];
    }

    // Modified date
    if (entry.fields.modified && entry.fields.modified['nb-NO']) {
      result.modified = moment(entry.fields.modified['nb-NO']).format('DD.MM.YYYY HH:mm');
    }

    return result;
  },

  internalToContentful(car) {
    const result = {
      fields: {
        priceAdjustment: {
          'nb-NO': parseInt(car.priceAdjustment, 10)
        }
      }
    };

    // Tags
    let tags = [];
    if (car.tags.length > 0) {
      tags = car.tags;
    }
    result.fields.tags = {
      'nb-NO': tags
    };

    // Color override link:
    if (typeof car.colorOverride !== 'undefined') {
      result.fields.colorOverride = {
        'nb-NO': car.colorOverride ? createEntryLink(car.colorOverride) : null
      };
    }

    return result;
  }
};

